import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Themes() {
  const [themes, setThemes] = useState([]);
  useEffect(() => {
    api.get("/themes").then(({ data }) => setThemes(data)).catch((err) => console.error("themes fetch failed", err));
  }, []);

  return (
    <div data-testid="themes-page" className="max-w-7xl mx-auto px-6 sm:px-10 py-20">
      <div className="label mb-6 text-[hsl(var(--accent))]">Themes</div>
      <h1 className="serif text-5xl sm:text-6xl text-foreground max-w-3xl">
        Which pattern is speaking to you?
      </h1>
      <p className="mt-6 text-muted-foreground max-w-2xl leading-relaxed">
        Six recurring arcs that bind concepts together across traditions. Pick the one that hums.
        Whichever you choose, the others will be waiting on the other side.
      </p>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border" data-testid="theme-grid">
        {themes.map((t, i) => (
          <Link
            key={t.id}
            to={`/theme/${t.id}`}
            data-testid={`theme-card-${t.id}`}
            className="bg-card p-8 sm:p-10 hover:bg-secondary transition-colors duration-500 group block"
          >
            <div className="flex items-baseline justify-between mb-5">
              <span className="serif text-3xl text-muted-foreground/30 group-hover:text-[hsl(var(--primary))] transition-colors">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground/75">
                {t.concept_ids?.length || 0} concepts
              </span>
            </div>
            <h3 className="serif text-2xl text-foreground group-hover:text-[hsl(var(--accent))] transition-colors leading-tight">
              {t.title}
            </h3>
            <p className="mt-3 text-muted-foreground text-[14px] leading-relaxed">{t.summary}</p>
            {t.tags?.length > 0 && (
              <div className="mt-5 flex flex-wrap gap-3">
                {t.tags.map((tag) => (
                  <span key={tag} className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground/75">
                    {tag}
                  </span>
                ))}
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
